module.exports = __webpack_public_path__ + "img/jts_web_banner_en.10f4a1b8.png";